module.exports = __webpack_public_path__ + "img/icon-popup-close-white.be327831.svg";